export default __webpack_public_path__ + "static/media/Hero.0f7e5fb5.png";